module.exports = __webpack_public_path__ + "img/rekuperace.fbec8d83.svg";